import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Details from './Details.jsx'
//import _ from 'lodash'

class ProfileComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    return <div><Details employee={this.props.employee}></Details></div>
  }
}

ProfileComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default ProfileComponent
